import React, { useState, useRef, useEffect } from 'react';
import './DemoInput.css';

const DemoInput = ({ onSendMessage, isLoading }) => {
  const [inputValue, setInputValue] = useState('');
  const textareaRef = useRef(null);

  // Auto-focus on component mount
  useEffect(() => {
    const focusInput = () => {
      if (textareaRef.current) {
        textareaRef.current.focus();
      }
    };

    // Initial focus
    const timer = setTimeout(focusInput, 100);
    
    return () => clearTimeout(timer);
  }, []);

  // Re-focus when loading stops (bot responds)
  useEffect(() => {
    if (!isLoading && textareaRef.current) {
      const timer = setTimeout(() => {
        textareaRef.current.focus();
      }, 300); // Small delay to let UI settle
      
      return () => clearTimeout(timer);
    }
  }, [isLoading]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!inputValue.trim() || isLoading) return;
    
    onSendMessage(inputValue);
    setInputValue('');
    
    if (textareaRef.current) {
      setTimeout(() => {
        textareaRef.current.focus();
      }, 100);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  // Handle container clicks to focus input
  const handleContainerClick = (e) => {
    if (textareaRef.current && e.target !== textareaRef.current) {
      textareaRef.current.focus();
    }
  };

  return (
    <div className="demo-unique-input-container" onClick={handleContainerClick}>
      <div className="demo-unique-input-wrapper">
        <textarea
          ref={textareaRef}
          className="demo-unique-textarea"
          placeholder="Type a message..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyDown={handleKeyDown}
          rows="1"
          disabled={isLoading}
        />
      </div>
      <button 
        className="demo-unique-send-btn" 
        onClick={handleSubmit}
        disabled={!inputValue.trim() || isLoading}
        aria-label="Send message"
      >
        ➤
      </button>
    </div>
  );
};

export default DemoInput;